exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-input--checkbox.v-input--indeterminate.v-input--is-disabled{opacity:.6}", ""]);

// exports
